import React, {
  startTransition,
  useCallback,
  useEffect,
  useState,
} from "react";
import { Box, styled } from "@mui/material";
import { useCurrentUser } from "../../../api-hooks/use-current-user";
import { Message } from "../../../api/message-request";
import { useMessagesBySenderAndReceiver } from "../../../api-hooks/use-messages-by-sender-and-receiver";
import ChatDetailTopBar from "./section/chat-detail-top-bar";
import ChatDetailMessages from "./section/chat-detail-messages";
import ChatDetailBottomBar from "./section/chat-detail-bottom-bar";
import { useSelectedUser } from "../../../api-hooks/use-selected-user";
import { useChatUsers } from "../../../api-hooks/use-chat-users";

const StyledContainer = styled(Box)(({ theme }) => ({
  flex: 3,
  backgroundColor: theme.palette.text.secondary,
  position: "relative",
  "& svg": {
    cursor: "pointer",
  },
}));

const ChatDetail = () => {
  const [messages, setMessages] = useState<Message[]>([]);

  const { user: loginUser } = useCurrentUser();
  const { updateLastMessage } = useChatUsers();
  const { selectedUser } = useSelectedUser();
  const { messages: dbMessages } = useMessagesBySenderAndReceiver({
    senderId: loginUser?.id ? loginUser?.id : 0,
    receiverId: selectedUser?.userId ? selectedUser?.userId : 0,
  });

  useEffect(() => {
    if (dbMessages) setMessages(dbMessages);
  }, [dbMessages]);

  const messageSentCallback = useCallback(
    (message: Message) => {
      setMessages((prevState) => prevState.concat(message));
      startTransition(() => {
        updateLastMessage({
          id: message.receiverId,
          lastMessageAt: message.sendAt,
          lastMessageText: message.text,
        });
      });
    },
    [updateLastMessage],
  );

  return (
    <StyledContainer>
      <ChatDetailTopBar />
      <ChatDetailMessages messages={messages} />
      <ChatDetailBottomBar messageSentCallback={messageSentCallback} />
    </StyledContainer>
  );
};

export default ChatDetail;
